import { Globals } from '@bwoty-web/ui-kit';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import CruiseListContainer from './containers/CruiseListContainer';
import { createCruiseListStore } from './redux/store/cruiseListStore';

const initialState = window.__INITIAL_STATE_IW_CRUISE_LIST__;
delete window.__INITIAL_STATE_IW_CRUISE_LIST__;

if (initialState) {
  const cruiseListStore = createCruiseListStore(initialState);
  const { siteSettings } = initialState;

  const root = createRoot(document.getElementById('iw-cruise-list'));
  root.render(
    <Globals
      siteId={siteSettings?.siteId || 1}
      legacyMode={siteSettings?.legacyMode}
    >
      <Provider store={cruiseListStore}>
        <CruiseListContainer />
      </Provider>
    </Globals>,
  );
}
